import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsAndConditions } from './components/TermsAndConditions';
import { DataDeletion } from './components/DataDeletion';
import { LegalIndex } from './components/LegalIndex';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LegalIndex data-id="element-3" />} data-id="element-2" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-5" />} data-id="element-4" />
        <Route path="/terminos-y-condiciones" element={<TermsAndConditions data-id="element-7" />} data-id="element-6" />
        <Route path="/eliminacion-de-datos" element={<DataDeletion data-id="element-9" />} data-id="element-8" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}